import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

export const authApi = (token) =>
  axios.create({
    baseURL: API_BASE,
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
  });

export const CONFIG = {
  brand: "Provident Winworth",
  tagline: "Redefining Grandeur With Fine Living Experiences",
  developer: "Puravankara Limited · Provident Housing",
  location: "Edappally, Kochi, Kerala",
  phone: "+91 88798 56585",
  phoneRaw: "+918879856585",
  phoneAlt: "+918879856585",
  tollFree: "+91 88798 56585",
  whatsapp: "918879856585",
  email: "sales@purvacitykochi.com",
  rera: "K-RERA/PRJ/ERN/020/2022",
  reraUrl: "https://rera.kerala.gov.in/",
  agentName: "Vidya Menon",
  agentRera: "K-RERA/AG/0090/2022",
  priceStart: "₹85 L ++",
  priceAllInclusive: "₹95 Lacs All-Inclusive",
  configurations: ["2.5 BHK"],
  amenitiesCount: 40,
  towers: 4,
  acres: 16,
  clubhouseSqft: "20,000",
  openSpace: "60%",
  status: "New Launch",
  possession: "Dec 2027",
};
